<template>
  <div class="styjCon">
    <div class="block">
      <vue-seamless-scroll :data="zzzwList"  :class-option="optionSetting">
        <div class="zzhiCov" v-for="(item,index) in zzzwList" :key="index">
          <img :src="item.cropPics" v-if="item.cropPics.includes('https')" alt="" class="zzzwBBanimg">  
          <img :src="urlimg+item.cropPics" v-else alt="" class="zzzwBBanimg">  
          <div class="rtcov">
            <div class="rtcov_tit">
               {{item.cropName}}
            </div>
            <div style="overflow:hidden;">
              <span class="rtcovcon_Lf">种植 <span>{{item.landCounts}}</span> 地块 </span>
              <span class="rtcovcon_Rt">种植面积 <span>{{item.plantAcre}}</span>  </span>
            </div>
            <!-- <img :src="urlimg+item.detailIcons" alt="" class="daoguimg"> -->
          </div>  
        </div>
      </vue-seamless-scroll>
    </div>
  </div>
</template>
  
<script>
export default {
  name: "HelloWorld",
  props:{
    zzzwList:Array,
    urlimg:String,
    farmId:String,
  },
  data() {
    return {
    };
  },
  created() {
    
  },
  computed:{
    optionSetting(){
      return{
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        autoPlay: true, // 是否自动滚动
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
  },
  methods: {
    
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped lang="less">
@import "@/assets/css/home.css";
.styjCon {
  width: 100%;
  height: 300px;
  overflow: hidden;
  .zzhiCov{
    width: 100%;
    height: 120px;
    border-radius: 12px;
    background: rgba(24, 152, 108, .4);
    margin-top: 14px;
    overflow: hidden;
    .zzzwBBanimg{
      width: 22.5%;
      // height: 100px;
      border-radius: 50%;
      float: left;
      margin-top: 10px;
      margin-left: 3%;
    }
    .rtcov{
      width: 63%;
      height: 100px;
      float: right;
      margin-top: 10px;
      margin-right: 2%;
      position: relative;
      .rtcov_tit{
        width: 60%;
        height: 28px;
        line-height: 28px;
        color: #fff;
        font-size: 14px;
        border-left: 4px solid #01E393;
        border-radius: 4px;
        background:  linear-gradient(to right, rgba(1, 227, 147, .3), rgba(1, 227, 147, 0));
        margin-top: 10px;
        margin-bottom: 30px;
        text-align: left;
        padding-left: 3%;
      }
      .rtcovcon_Lf{
        float: left;
        font-size: 14px;
        color: #fff;
        span{
          color: #EECF0A;
          font-size: 22px;
          font-family:"UnidreamLED" ;
        }
      }
      .rtcovcon_Rt{
        float: right;
        font-size: 14px;
        color: #fff;
        span{
          color: #EECF0A;
          font-size: 18px;
          font-family:"UnidreamLED" ;
        }
      }
      .daoguimg{
        width: 36px;
        height: 40px;
        position: absolute;
        right: 20px;
        top: 10px;
      }
    }
  }
}
/* 定义滚动条样式 */
.styjCon::-webkit-scrollbar {
  width: 2px;
  height: 2px;
  background-color: rgba(240, 240, 240, 0.1);
}
/*定义滚动条轨道 内阴影+圆角*/
.styjCon::-webkit-scrollbar-track {
  box-shadow: inset 0 0 0px rgba(240, 240, 240, 0);
  border-radius: 10px;
  background-color: rgba(240, 240, 240, 0);
}
/*定义滑块 内阴影+圆角*/
.styjCon::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 0px rgba(36, 132, 109, 0.8);
  background-color: rgba(36, 132, 109, 0.8);
}

</style>
  
  
  